import React from 'react';
import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import './bodyMarkersDefault.scss';
import { notify } from '../../../../functions/notifications';
import { constantes } from '../../../../constantes';

function MarkersDefalut({ detalhes }) {
  const {
    idUsuario, estado, idEstado, nome,
    celular, dataAprov, positions, dataCad, fone, cidade, tipo,
  } = detalhes;
  const { tipoCadastro } = constantes;
  const { titulo, description, urlImg } = tipoCadastro.find((result) => result.valor === tipo);
  const quantidadeDeColmeias = detalhes?.quandidadeColmeias;
  const tipoDeApiario = detalhes?.localizacaoapiario;
  const tipoDeApiarioP = detalhes?.apiarioPermanente;
  const propositoApiario = detalhes?.propositoApicultura;
  const dataInicialApiario = detalhes?.dataInicial;
  const dataFinalApiario = detalhes?.dataFinal;
  const duracaoApiario = `${tipoDeApiario || tipoDeApiarioP}, ${
    tipoDeApiario
      ? `Início: ${dataInicialApiario}, Término: ${dataFinalApiario}`
      : `Data de Cadastro: ${dataCad}`
  }`;

  return (
    <div id="agrupamento-de-animal">
      <div className="agrupamento-header">
        <div className="agrupamento-titulo">
          <strong>
            {titulo}
          </strong>
          <span>
            {`AGSF-${String(idUsuario)
              .padStart(4, '0')}${estado}-${String(idEstado)
              .padStart(4, '0')} - Aprovado: ${dataAprov === '00/00/0000' ? 'Pendente' : dataAprov}`}
          </span>
        </div>
        <div className="agrupamento-icone">
          <img src={urlImg} alt="Animais" />
        </div>
      </div>
      <div className="agrupamento-informante">
        <div className="separator">
          / /
        </div>
        <div className="agrupamento-dados-informante">
          <strong>
            Descrição:
            <span>
              {detalhes[`${description}`]}
            </span>
          </strong>
          <strong>
            Localidade:
            <span>
              {`${cidade} - ${estado}`}
            </span>
          </strong>
          <strong>
            Cadastrado por:
            <span>
              {`${nome.split(' ')[0]}, dia ${dataCad}`}
            </span>
          </strong>
          <strong>
            Telefone:
            <span>
              {celular}
            </span>
            <span>
              {` ${fone !== celular ? fone : ''}`}
            </span>
          </strong>
          {(tipoDeApiario || tipoDeApiarioP) && (
          <>
            <strong>
              Propósito:
              <span>
                {`${propositoApiario}, Número de Colméias: ${quantidadeDeColmeias}`}
              </span>
            </strong>
            <strong>
              Tipo:
              <span>
                {`${duracaoApiario}`}
              </span>
            </strong>
          </>
          )}
          <strong>
            Lat/Lng:
            <span>
              {`${positions[0].lat}, ${positions[0].lng}`}
            </span>
            <button
              onClick={() => {
                notify('success', 'Coordendas copiadas');
                copy(`${positions[0].lat}, ${positions[0].lng}`);
              }}
              type="button"
              className="buttons-transparent"
            >
              <i className="far fa-clone" />
            </button>
          </strong>
        </div>
      </div>
    </div>
  );
}

MarkersDefalut.propTypes = {
  detalhes: PropTypes.shape().isRequired,
};

export default MarkersDefalut;
